import moment from "moment";

export const PAGE_SIZE = 10;

// Normalize a reducer error (string | string[] | {field:[msg]}) into a flat list.
export const toMessages = (error, fallback = "Something went wrong.") => {
  if (!error) return [fallback];
  if (Array.isArray(error)) {
    const flat = error.filter(Boolean);
    return flat.length ? flat : [fallback];
  }
  if (typeof error === "string") return [error];
  if (typeof error?.message === "string") return [error.message];
  if (typeof error === "object") {
    const msgs = [];
    Object.values(error).forEach((v) => {
      if (Array.isArray(v)) v.forEach((m) => m && msgs.push(m));
      else if (typeof v === "string") msgs.push(v);
    });
    return msgs.length ? msgs : [fallback];
  }
  return [fallback];
};

export const formatDateTime = (value) => {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("lll") : "—";
};

// A resolution list can arrive paginated ({results|data}) or as a plain array
// (history=true). Read rows/count defensively either way.
export const readResolutionRows = (list) => {
  if (Array.isArray(list)) return list;
  return list?.results || list?.data || [];
};
export const readResolutionCount = (list) => {
  if (Array.isArray(list)) return list.length;
  return list?.count || 0;
};

// Pull a single field's server error from a { field: [msg] } map.
export const serverFieldError = (fieldErrors, key) => {
  const val = fieldErrors?.[key];
  if (!val) return "";
  if (Array.isArray(val)) return val.filter(Boolean).join(" ");
  if (typeof val === "string") return val;
  return "";
};
